// extracted by mini-css-extract-plugin
export default {"NewsLetter":"newsLetter_NewsLetter__mbehy","NewsLetterForm":"newsLetter_NewsLetterForm__LOvvS"};